// import React from "react";
// import TableUtility from "../../../Common/UtilityCommon/TableUtility"; 

// const GulSaleBillUtility = ({includeYearCode =true}) => {
//     const apiUrl = `${process.env.REACT_APP_API}/getdata-GulSaleBill`;
//     const columns = [
//         { label: "Doc No", key: "doc_no" },
//         { label: "Doc Date", key: "doc_date" },
//         { label: "Customer Name", key: "Ac_Name_E" },
//         { label: "Broker Name", key: "BrokerName" },
//         { label: "NET Quintal", key: "Net_quantity",format: true },
//         { label: "Bill Amount", key: "Bill_Amount",format: true },
//         { label: "SaleId", key: "salebillId" },

//     ];



//      const getRowStyle = (row) => {
//         if (row.IsDeleted === 0) {
//             return { backgroundColor: '#ffcccc' };
//         }
//         return {}; 
//     };

//     return (
//         <TableUtility
//             title="Gul Sale Bill"
//             apiUrl={apiUrl}
//             columns={columns}
//             rowKey="salebillId"
//             addUrl="/Gulsale-bill"
//             detailUrl="/Gulsale-bill"
//             permissionUrl="/GulSaleBill-utility"
//             includeYearCode = {includeYearCode}
//             getRowStyle={getRowStyle}
//         />
//     );
// };

// export default GulSaleBillUtility;

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PageNotFound from "../../../Common/PageNotFound/PageNotFound";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid,
    Paper,
    Typography, Box
} from "@mui/material";
import Pagination from "../../../Common/UtilityCommon/Pagination";
import SearchBar from "../../../Common/UtilityCommon/SearchBar";
import PerPageSelect from "../../../Common/UtilityCommon/PerPageSelect";
import BackButton from "../../../Common/Buttons/BackButton";
import CreateNewButton from "../../../Common/Buttons/CreateNewButton";
import CircularSpinner from "../../../Common/Spinners/CircularSpinner";
import axios from "axios";

const API_URL = process.env.REACT_APP_API;

const styles = {
    tableHeaderCell: {
        fontSize: '16px',
        fontWeight: 'bold',
        backgroundColor: '#f4f4f4',
        whiteSpace: 'nowrap',
        position: 'sticky',
        top: 0,
        zIndex: 1
    }
};

function HaladSaleBillUtility() {
    const companyCode = sessionStorage.getItem('Company_Code');
    const Year_Code = sessionStorage.getItem('Year_Code');

    const uid = sessionStorage.getItem('uid');
    const [fetchedData, setFetchedData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [perPage, setPerPage] = useState(15);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const location = useLocation();

    const [filterValue, setFilterValue] = useState(
        location.state?.Tran_Type || "GS"
    );
    const [canView, setCanView] = useState(null);
    const [permissionsData, setPermissionData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkPermissions = async () => {
            try {
                const userCheckUrl = `${API_URL}/get_user_permissions?Company_Code=${companyCode}&Program_Name=/HaladSaleBill-utility&uid=${uid}`;
                const response = await axios.get(userCheckUrl);
                setPermissionData(response.data?.UserDetails);
                if (response.data?.UserDetails?.canView === 'Y') {
                    setCanView(true);
                    fetchData();
                } else {
                    setCanView(false);
                }
            } catch (error) {
                console.error("Error fetching user permissions:", error);
                setCanView(false);
            }
        };

        const fetchData = async () => {
            setIsLoading(true);
            const companyCode = sessionStorage.getItem('Company_Code');
            const YearCode = sessionStorage.getItem('Year_Code');
            try {
                const apiUrl = `${API_URL}/getdata-GulSaleBill?Company_Code=${companyCode}&Year_Code=${YearCode}`;
                const response = await axios.get(apiUrl);
                setFetchedData(response.data.all_data);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };
        checkPermissions();
    }, []);


    useEffect(() => {
        const filtered = fetchedData.filter(post => {
            const searchTermLower = searchTerm.toLowerCase();
            return (
                (filterValue === "" || post.Tran_Type === filterValue) &&
                (String(post.doc_no).includes(searchTermLower) ||
                    post.Ac_Name_E.toLowerCase().includes(searchTermLower))
            );
        });

        setFilteredData(filtered);
        setCurrentPage(1);
    }, [searchTerm, filterValue, fetchedData]);

    if (canView === false) {
        return <PageNotFound />;
    }

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
        setCurrentPage(1);
    };

    const handleSearchTermChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
    };

    const pageCount = Math.ceil(filteredData.length / perPage);

    const paginatedPosts = filteredData.slice((currentPage - 1) * perPage, currentPage * perPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleClick = () => {
        const selectedfilter = filterValue
        navigate("/Haladsale-bill", { state: { selectedfilter } });

    };

    const handleRowClick = (salebillId) => {
        const selectedRecord = filteredData.find(record => record.salebillId === salebillId);
        navigate("/Haladsale-bill", { state: { selectedRecord } });
    };

    const handleSearchClick = () => {
        setFilterValue("");
    };

    const handleBack = () => {
        navigate("/DashBoard")
    }

    return (
        <div style={{ padding: '10px', overflow: 'hidden' }} >
            <Grid container alignItems="center" spacing={1}>
                <Grid item>
                    <CreateNewButton
                        onClick={handleClick}
                        disabled={permissionsData.canSave === "N"}
                        permissionsData={permissionsData}
                    />
                </Grid>
                <Grid item>
                    <BackButton onClick={handleBack} />
                </Grid>
                <Grid item>
                    <PerPageSelect value={perPage} onChange={handlePerPageChange} />
                </Grid>
                <Grid item>
                    <FormControl sx={{ minWidth: 200 }} size="small">
                        <InputLabel>Filter by Type</InputLabel>
                        <Select
                            labelId="filterSelect-label"
                            id="filterSelect"
                            value={filterValue}
                            onChange={(e) => setFilterValue(e.target.value)}
                            label="Filter by Type"
                        >
                            <MenuItem value="GS">GS</MenuItem>
                            <MenuItem value="OS">OutSide City</MenuItem>
                            <MenuItem value="MS">MAHALINGPUR Sale</MenuItem>


                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs ml={-20}>
                    <Typography variant="h6" align="center" fontWeight="bold">
                        Halad Sale Bill
                    </Typography>
                </Grid>
                <Grid item >
                    <SearchBar
                        value={searchTerm}
                        onChange={handleSearchTermChange}
                        onSearchClick={handleSearchClick}
                    />
                </Grid>
            </Grid>

            <Grid item xs={12}>
                {isLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="600px">
                        <CircularSpinner />
                    </Box>
                ) : (
                    <Paper elevation={20}>
                        <TableContainer sx={{ maxHeight: 600 }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: "#f4f4f4" }}>
                                        <TableCell style={styles.tableHeaderCell}>Doc No</TableCell>
                                        <TableCell style={styles.tableHeaderCell}>Doc Date</TableCell>
                                        <TableCell style={styles.tableHeaderCell}>Tran Type</TableCell>
                                        <TableCell style={styles.tableHeaderCell}>Customer Name</TableCell>
                                        <TableCell style={styles.tableHeaderCell}>Broker Name</TableCell>
                                        <TableCell style={styles.tableHeaderCell}>NET Quintal</TableCell>
                                        <TableCell style={styles.tableHeaderCell}>Bill Amount</TableCell>
                                        <TableCell style={styles.tableHeaderCell}>SaleId</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedPosts.map((post) => (
                                        <TableRow
                                            key={post.doc_no}
                                            onDoubleClick={() => handleRowClick(post.salebillId)}
                                            sx={{
                                                cursor: "pointer",
                                                transition: "background-color 0.3s ease, box-shadow 0.2s ease",
                                                '&:hover': {
                                                    backgroundColor: '#f3f388',
                                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                                                },
                                            }}
                                        >
                                            <TableCell>{post.doc_no}</TableCell>
                                            <TableCell>{post.doc_date}</TableCell>
                                            <TableCell>{post.Tran_Type}</TableCell>
                                            <TableCell>{post.Ac_Name_E}</TableCell>
                                            <TableCell>{post.BrokerName}</TableCell>
                                            <TableCell>{post.Net_quantity}</TableCell>
                                            <TableCell>{post.Bill_Amount}</TableCell>
                                            <TableCell>{post.salebillId}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                )}
            </Grid>
            <Grid item xs={12} mb={10}>
                <Pagination
                    pageCount={pageCount}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            </Grid>
        </div>
    );
}

export default HaladSaleBillUtility;

